import React from 'react';
import DownloadCsvButton from '../productsTab/DownloadCsvButton';
import { exportRecipesToCsv } from '../../services/recipesCsvExportService';

const DownloadRecipesCsvButton = () => (
    <DownloadCsvButton
        labelKey="app.page.recipe.downloadCSV"
        onExport={exportRecipesToCsv}
    />
);

export default DownloadRecipesCsvButton;
